// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * tournament-ui.css - Tournament UI Component Styles
 * 
 * Styles for tournament bracket, lobby, and results components
 * Following the retro pixel art aesthetic with terminal green colors
 */

/* ===== TOURNAMENT BRACKET PANEL ===== */
.tournament-bracket-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}

.tournament-bracket-modal {
    width: 95vw;
    height: 90vh;
    background: rgba(0, 0, 0, 0.95);
    border: 2px solid #0088ff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 30px rgba(0, 255, 0, 0.5);
}

.bracket-controls {
    display: flex;
    gap: 8px;
    align-items: center;
}

.control-btn {
    background: rgba(0, 255, 0, 0.1);
    color: #0088ff;
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 4px 8px;
    font-family: inherit;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.control-btn:hover {
    background: rgba(0, 255, 0, 0.2);
    border-color: #0088ff;
}

.tournament-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    background: rgba(0, 255, 0, 0.05);
    border-bottom: 1px solid rgba(0, 255, 0, 0.2);
}

.tournament-status,
.tournament-progress,
.tournament-participants {
    display: flex;
    gap: 8px;
    align-items: center;
}

.status-value,
.progress-value,
.participants-value {
    color: #ffffff;
    font-weight: bold;
}

.bracket-format-tabs {
    display: flex;
    gap: 4px;
    padding: 8px 12px;
    background: rgba(0, 0, 0, 0.3);
    border-bottom: 1px solid rgba(0, 255, 0, 0.2);
}

.format-tab {
    background: rgba(0, 255, 0, 0.1);
    color: #0088ff;
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 8px 12px;
    font-family: inherit;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 6px;
}

.format-tab.active {
    background: rgba(0, 255, 0, 0.3);
    border-color: #0088ff;
    color: #000;
    background-color: #0088ff;
}

.format-tab:hover:not(.active) {
    background: rgba(0, 255, 0, 0.2);
}

.bracket-container {
    flex: 1;
    overflow: hidden;
    position: relative;
}

.bracket-viewport {
    width: 100%;
    height: 100%;
    overflow: hidden;
    cursor: grab;
    position: relative;
}

.bracket-viewport:active {
    cursor: grabbing;
}

.bracket-canvas {
    position: relative;
    transform-origin: 0 0;
    transition: transform 0.2s ease;
    min-width: 100%;
    min-height: 100%;
}

.bracket-round {
    position: absolute;
}

.bracket-match {
    position: absolute;
    background: rgba(0, 255, 0, 0.1);
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.bracket-match:hover,
.bracket-match.hovered {
    background: rgba(0, 255, 0, 0.2);
    border-color: #0088ff;
    box-shadow: 0 0 10px rgba(0, 255, 0, 0.3);
}

.bracket-match.status-pending {
    border-color: #666;
    color: #999;
}

.bracket-match.status-active {
    border-color: #ffff00;
    background: rgba(255, 255, 0, 0.1);
    animation: pulse-yellow 2s infinite;
}

.bracket-match.status-completed {
    border-color: #0088ff;
}

.bracket-match.newly-completed {
    animation: flash-green 2s ease;
}

@keyframes pulse-yellow {
    0%, 100% { opacity: 0.7; }
    50% { opacity: 1.0; }
}

@keyframes flash-green {
    0% { background: rgba(0, 255, 0, 0.1); }
    50% { background: rgba(0, 255, 0, 0.5); }
    100% { background: rgba(0, 255, 0, 0.1); }
}

.match-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
    font-size: 10px;
}

.match-id {
    font-weight: bold;
    color: #0088ff;
}

.match-status {
    text-transform: uppercase;
    font-size: 9px;
}

.match-status.pending {
    color: #666;
}

.match-status.active {
    color: #ffff00;
}

.match-status.completed {
    color: #0088ff;
}

.match-players {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.match-player {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2px 4px;
    border-radius: 2px;
    font-size: 11px;
}

.match-player.winner {
    background: rgba(0, 255, 0, 0.2);
    color: #0088ff;
    font-weight: bold;
}

.match-vs {
    text-align: center;
    font-size: 9px;
    color: #666;
    margin: 2px 0;
}

.winner-icon {
    font-size: 10px;
}

.standings-container,
.matches-container {
    flex: 1;
    overflow-y: auto;
    padding: 12px;
}

.standings-table-wrapper {
    overflow-x: auto;
}

.standings-table {
    width: 100%;
    border-collapse: collapse;
    background: rgba(0, 0, 0, 0.3);
}

.standings-table th,
.standings-table td {
    padding: 8px 12px;
    text-align: left;
    border-bottom: 1px solid rgba(0, 255, 0, 0.2);
    font-size: 12px;
}

.standings-table th {
    background: rgba(0, 255, 0, 0.1);
    color: #0088ff;
    font-weight: bold;
    position: sticky;
    top: 0;
}

.standings-row.eliminated {
    opacity: 0.6;
}

.standings-row.finalist {
    background: rgba(0, 255, 0, 0.05);
}

.rank-badge {
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    text-align: center;
    line-height: 24px;
    font-weight: bold;
    font-size: 11px;
}

.rank-badge.gold {
    background: linear-gradient(45deg, #FFD700, #FFA500);
    color: #000;
}

.rank-badge.silver {
    background: linear-gradient(45deg, #C0C0C0, #808080);
    color: #000;
}

.rank-badge.bronze {
    background: linear-gradient(45deg, #CD7F32, #8B4513);
    color: #fff;
}

.match-details-panel {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    width: 300px;
    background: rgba(0, 0, 0, 0.95);
    border: 2px solid #0088ff;
    border-radius: 4px;
    padding: 16px;
    visibility: hidden;
    opacity: 0;
    transition: all 0.3s ease;
}

.match-details-panel.visible {
    visibility: visible;
    opacity: 1;
}

.match-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.match-title {
    font-weight: bold;
    color: #0088ff;
}

.close-details-btn {
    background: none;
    border: none;
    color: #0088ff;
    font-size: 16px;
    cursor: pointer;
    padding: 0;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.match-detail-row {
    margin-bottom: 8px;
    font-size: 12px;
}

.detail-label {
    color: #0088ff;
    font-weight: bold;
}

.detail-value {
    color: #ffffff;
}

.detail-players {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 4px;
}

.detail-player {
    padding: 4px 8px;
    border-radius: 2px;
    background: rgba(0, 255, 0, 0.05);
}

.detail-player.winner {
    background: rgba(0, 255, 0, 0.2);
    color: #0088ff;
    font-weight: bold;
}

.detail-vs {
    text-align: center;
    color: #666;
    font-size: 10px;
}

.bracket-legend {
    display: flex;
    gap: 16px;
    align-items: center;
}

.legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
}

.legend-color {
    width: 12px;
    height: 12px;
    border-radius: 2px;
}

.legend-color.pending {
    background: #666;
}

.legend-color.active {
    background: #ffff00;
}

.legend-color.completed {
    background: #0088ff;
}

/* ===== TOURNAMENT LOBBY PANEL ===== */
.tournament-lobby-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}

.tournament-lobby-modal {
    width: 90vw;
    height: 85vh;
    max-width: 1200px;
    background: rgba(0, 0, 0, 0.95);
    border: 2px solid #0088ff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 30px rgba(0, 255, 0, 0.5);
}

.lobby-nav {
    display: flex;
    gap: 4px;
}

.nav-btn {
    background: rgba(0, 255, 0, 0.1);
    color: #0088ff;
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 6px 12px;
    font-family: inherit;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 6px;
}

.nav-btn.active {
    background: #0088ff;
    color: #000;
}

.nav-btn:hover:not(.active) {
    background: rgba(0, 255, 0, 0.2);
}

.view-container {
    flex: 1;
    padding: 16px;
    overflow-y: auto;
}

.view-container.hidden {
    display: none;
}

.tournaments-filters {
    display: flex;
    gap: 16px;
    align-items: center;
    margin-bottom: 16px;
    padding: 12px;
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 4px;
}

.filter-group {
    display: flex;
    align-items: center;
    gap: 8px;
}

.filter-select {
    background: rgba(0, 0, 0, 0.7);
    color: #0088ff;
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 4px 8px;
    font-family: inherit;
    font-size: 12px;
}

.refresh-btn {
    background: rgba(0, 255, 0, 0.1);
    color: #0088ff;
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 6px 12px;
    font-family: inherit;
    font-size: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s ease;
}

.refresh-btn:hover {
    background: rgba(0, 255, 0, 0.2);
}

.tournaments-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.tournament-item {
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 16px;
    transition: all 0.2s ease;
}

.tournament-item:hover {
    background: rgba(0, 255, 0, 0.1);
    border-color: #0088ff;
}

.tournament-item.status-registration {
    border-left: 4px solid #ffff00;
}

.tournament-item.status-active {
    border-left: 4px solid #ff8800;
}

.tournament-item.status-completed {
    border-left: 4px solid #0088ff;
}

.tournament-main-info {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
}

.tournament-name {
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    margin-bottom: 4px;
}

.tournament-meta {
    display: flex;
    gap: 12px;
    align-items: center;
}

.tournament-format,
.tournament-status {
    padding: 2px 6px;
    border-radius: 2px;
    font-size: 10px;
    font-weight: bold;
    text-transform: uppercase;
}

.tournament-format {
    background: rgba(0, 255, 0, 0.2);
    color: #0088ff;
}

.tournament-status.status-registration {
    background: rgba(255, 255, 0, 0.2);
    color: #ffff00;
}

.tournament-status.status-active {
    background: rgba(255, 136, 0, 0.2);
    color: #ff8800;
}

.tournament-status.status-completed {
    background: rgba(0, 255, 0, 0.2);
    color: #0088ff;
}

.tournament-details {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 8px;
    margin-bottom: 12px;
}

.detail-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
}

.detail-label {
    color: #0088ff;
    font-weight: bold;
}

.detail-value {
    color: #ffffff;
}

.detail-value.urgent {
    color: #ff0000;
    animation: pulse 1s infinite;
}

.detail-value.prize {
    color: #ffff00;
    font-weight: bold;
}

.tournament-actions {
    display: flex;
    gap: 8px;
    align-items: center;
}

.join-btn {
    background: rgba(0, 255, 0, 0.2);
    color: #0088ff;
}

.spectate-btn {
    background: rgba(0, 136, 255, 0.2);
    color: #0088ff;
}

.info-btn {
    background: rgba(255, 255, 0, 0.2);
    color: #ffff00;
}

/* Create Tournament Form */
.create-tournament-form {
    max-width: 600px;
    margin: 0 auto;
}

.form-section {
    margin-bottom: 24px;
}

.section-title {
    color: #0088ff;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 16px;
    padding-bottom: 4px;
    border-bottom: 1px solid rgba(0, 255, 0, 0.3);
}

.form-row {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 12px;
}

.form-row label {
    color: #0088ff;
    font-size: 12px;
    font-weight: bold;
}

.form-row-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 12px;
}

.form-input,
.form-select {
    background: rgba(0, 0, 0, 0.7);
    color: #ffffff;
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 8px 12px;
    font-family: inherit;
    font-size: 12px;
}

.form-input:focus,
.form-select:focus {
    outline: none;
    border-color: #0088ff;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.3);
}

.checkbox-label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    color: #0088ff;
    font-size: 12px;
}

.checkbox-custom {
    width: 16px;
    height: 16px;
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 2px;
    position: relative;
    background: rgba(0, 0, 0, 0.7);
}

.checkbox-label input[type="checkbox"] {
    display: none;
}

.checkbox-label input[type="checkbox"]:checked + .checkbox-custom {
    background: #0088ff;
}

.checkbox-label input[type="checkbox"]:checked + .checkbox-custom::after {
    content: '✓';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #000;
    font-size: 12px;
    font-weight: bold;
}

.form-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
    margin-top: 24px;
}

.create-btn {
    background: rgba(0, 255, 0, 0.2);
    color: #0088ff;
}

.cancel-btn {
    background: rgba(255, 0, 0, 0.2);
    color: #ff0000;
}

/* Tournament Lobby View */
.tournament-header {
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 16px;
}

.tournament-title {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
}

.tournament-name {
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
}

.tournament-badges {
    display: flex;
    gap: 8px;
    align-items: center;
}

.format-badge,
.status-badge,
.spectator-badge {
    padding: 2px 6px;
    border-radius: 2px;
    font-size: 10px;
    font-weight: bold;
    text-transform: uppercase;
}

.format-badge {
    background: rgba(0, 255, 0, 0.2);
    color: #0088ff;
}

.status-badge.status-registration {
    background: rgba(255, 255, 0, 0.2);
    color: #ffff00;
}

.status-badge.status-active {
    background: rgba(255, 136, 0, 0.2);
    color: #ff8800;
}

.spectator-badge {
    background: rgba(0, 136, 255, 0.2);
    color: #0088ff;
}

.tournament-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 16px;
}

.stat-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.stat-label {
    color: #0088ff;
    font-size: 11px;
    font-weight: bold;
}

.stat-value {
    color: #ffffff;
    font-size: 14px;
}

.stat-value.prize {
    color: #ffff00;
    font-weight: bold;
}

.lobby-main {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 24px;
    margin-bottom: 16px;
}

.players-section,
.chat-section {
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 4px;
    padding: 16px;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.section-title {
    color: #0088ff;
    font-size: 14px;
    font-weight: bold;
}

.player-count {
    color: #ffffff;
    font-size: 12px;
}

.players-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 12px;
    margin-bottom: 16px;
}

.player-card {
    background: rgba(0, 255, 0, 0.1);
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 12px;
    transition: all 0.2s ease;
}

.player-card.current-user {
    border-color: #ffff00;
    background: rgba(255, 255, 0, 0.1);
}

.player-card.empty {
    border-style: dashed;
    opacity: 0.5;
    justify-content: center;
}

.player-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(0, 255, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: #0088ff;
}

.player-info {
    flex: 1;
}

.player-name {
    font-weight: bold;
    color: #ffffff;
    margin-bottom: 2px;
}

.player-meta {
    display: flex;
    gap: 8px;
    font-size: 10px;
    color: #999;
}

.current-user-indicator {
    background: #ffff00;
    color: #000;
    padding: 2px 6px;
    border-radius: 2px;
    font-size: 9px;
    font-weight: bold;
}

.empty-slot {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    color: #666;
}

.empty-icon {
    font-size: 18px;
}

.empty-text {
    font-size: 10px;
}

.registration-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
}

.leave-tournament-btn {
    background: rgba(255, 0, 0, 0.2);
    color: #ff0000;
}

.ready-btn {
    background: rgba(0, 255, 0, 0.2);
    color: #0088ff;
}

.join-tournament-btn {
    background: rgba(0, 255, 0, 0.2);
    color: #0088ff;
}

/* Chat Section */
.chat-controls {
    display: flex;
    gap: 4px;
}

.chat-control-btn {
    background: rgba(0, 255, 0, 0.1);
    color: #0088ff;
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 2px;
    padding: 2px 4px;
    font-size: 10px;
    cursor: pointer;
}

.chat-messages {
    height: 200px;
    overflow-y: auto;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 4px;
    padding: 8px;
    margin-bottom: 8px;
}

.chat-message {
    margin-bottom: 8px;
    font-size: 11px;
}

.chat-message.type-system {
    color: #ffff00;
    font-style: italic;
}

.chat-message.type-player {
    color: #ffffff;
}

.message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2px;
}

.sender-name {
    font-weight: bold;
    color: #0088ff;
}

.message-time {
    color: #666;
    font-size: 9px;
}

.message-content {
    color: #ffffff;
}

.chat-input-section {
    display: flex;
    gap: 8px;
}

.chat-input {
    flex: 1;
    background: rgba(0, 0, 0, 0.7);
    color: #ffffff;
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 6px 8px;
    font-family: inherit;
    font-size: 11px;
}

.send-btn {
    background: rgba(0, 255, 0, 0.2);
    color: #0088ff;
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 6px 8px;
    cursor: pointer;
    font-size: 10px;
}

/* Countdown Section */
.countdown-section {
    text-align: center;
    padding: 16px;
    background: rgba(255, 255, 0, 0.1);
    border: 1px solid rgba(255, 255, 0, 0.3);
    border-radius: 4px;
}

.countdown-timer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.countdown-label {
    color: #ffff00;
    font-size: 12px;
    font-weight: bold;
}

.countdown-display {
    color: #ffffff;
    font-size: 24px;
    font-weight: bold;
    font-family: 'Courier New', monospace;
}

/* Footer */
.panel-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: rgba(0, 0, 0, 0.5);
    border-top: 1px solid rgba(0, 255, 0, 0.2);
}

.footer-info {
    display: flex;
    gap: 16px;
    font-size: 11px;
    color: #999;
}

/* ===== TOURNAMENT RESULTS PANEL ===== */
.tournament-results-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}

.tournament-results-modal {
    width: 90vw;
    height: 85vh;
    max-width: 1200px;
    background: rgba(0, 0, 0, 0.95);
    border: 2px solid #0088ff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 30px rgba(0, 255, 0, 0.5);
}

.results-nav {
    display: flex;
    gap: 4px;
}

.tournament-summary {
    background: rgba(0, 255, 0, 0.05);
    border-bottom: 1px solid rgba(0, 255, 0, 0.2);
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.summary-main {
    flex: 1;
}

.tournament-title {
    color: #ffffff;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 12px;
}

.tournament-info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 16px;
}

.info-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.info-label {
    color: #0088ff;
    font-size: 11px;
    font-weight: bold;
}

.info-value {
    color: #ffffff;
    font-size: 14px;
}

.winner-spotlight {
    background: linear-gradient(45deg, rgba(255, 215, 0, 0.1), rgba(255, 215, 0, 0.05));
    border: 2px solid #FFD700;
    border-radius: 8px;
    padding: 16px;
    text-align: center;
    min-width: 200px;
}

.winner-crown {
    font-size: 24px;
    margin-bottom: 8px;
}

.winner-name {
    color: #FFD700;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 4px;
}

.winner-title {
    color: #ffffff;
    font-size: 12px;
    margin-bottom: 8px;
}

.winner-stats {
    display: flex;
    justify-content: space-around;
    gap: 8px;
}

.winner-stat {
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 10px;
}

.winner-stat .stat-label {
    color: #0088ff;
}

.winner-stat .stat-value {
    color: #ffffff;
    font-weight: bold;
}

.winner-stat .stat-value.prize {
    color: #FFD700;
}

/* Standings View */
.standings-section {
    padding: 16px;
}

.standings-controls {
    display: flex;
    gap: 8px;
}

.sort-btn {
    background: rgba(0, 255, 0, 0.1);
    color: #0088ff;
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 4px 8px;
    font-size: 11px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
}

.sort-btn.active {
    background: rgba(0, 255, 0, 0.3);
    border-color: #0088ff;
}

.standings-table-container {
    margin: 16px 0;
    overflow-x: auto;
}

.results-table {
    width: 100%;
    border-collapse: collapse;
    background: rgba(0, 0, 0, 0.3);
}

.results-table th,
.results-table td {
    padding: 8px 12px;
    text-align: left;
    border-bottom: 1px solid rgba(0, 255, 0, 0.2);
    font-size: 12px;
}

.results-table th {
    background: rgba(0, 255, 0, 0.1);
    color: #0088ff;
    font-weight: bold;
    position: sticky;
    top: 0;
}

.standings-row.rank-1 {
    background: rgba(255, 215, 0, 0.1);
}

.standings-row.rank-2 {
    background: rgba(192, 192, 192, 0.1);
}

.standings-row.rank-3 {
    background: rgba(205, 127, 50, 0.1);
}

.standings-row.eliminated {
    opacity: 0.6;
}

.prize-cell.has-prize {
    color: #FFD700;
    font-weight: bold;
}

.podium-display {
    margin-top: 24px;
    display: flex;
    justify-content: center;
}

.podium {
    display: flex;
    align-items: end;
    gap: 8px;
}

.podium-position {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.podium-player {
    background: rgba(0, 255, 0, 0.1);
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 12px;
    text-align: center;
    min-width: 100px;
}

.podium-rank {
    font-size: 18px;
    font-weight: bold;
    color: #0088ff;
}

.podium-name {
    color: #ffffff;
    font-size: 14px;
    margin: 4px 0;
}

.podium-prize {
    color: #FFD700;
    font-size: 12px;
    font-weight: bold;
}

.podium-base {
    font-size: 32px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.podium-position.first .podium-base {
    height: 80px;
}

.podium-position.second .podium-base {
    height: 70px;
}

.podium-position.third .podium-base {
    height: 60px;
}

/* Match History */
.history-section {
    padding: 16px;
}

.history-controls {
    display: flex;
    gap: 12px;
}

.matches-timeline {
    margin-top: 16px;
}

.timeline-round {
    margin-bottom: 24px;
}

.round-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 4px;
    border-bottom: 1px solid rgba(0, 255, 0, 0.3);
}

.round-title {
    color: #0088ff;
    font-size: 14px;
    font-weight: bold;
}

.round-meta {
    color: #999;
    font-size: 11px;
}

.round-matches {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.timeline-match {
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 4px;
    padding: 12px;
}

.match-timeline-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
    font-size: 11px;
}

.match-id {
    color: #0088ff;
    font-weight: bold;
}

.match-time {
    color: #999;
}

.match-timeline-players {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
}

.timeline-player {
    flex: 1;
    padding: 4px 8px;
    border-radius: 2px;
    text-align: center;
    font-size: 12px;
}

.timeline-player.winner {
    background: rgba(0, 255, 0, 0.2);
    color: #0088ff;
    font-weight: bold;
}

.timeline-player.loser {
    background: rgba(255, 0, 0, 0.1);
    color: #999;
}

.timeline-vs {
    color: #666;
    font-size: 10px;
}

.match-timeline-stats {
    font-size: 10px;
    color: #999;
}

/* Statistics View */
.statistics-section {
    padding: 16px;
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
}

.stats-card {
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 4px;
    padding: 16px;
}

.stats-card-title {
    color: #0088ff;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 12px;
    padding-bottom: 4px;
    border-bottom: 1px solid rgba(0, 255, 0, 0.3);
}

.stats-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.stat-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
}

.player-performance-chart {
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 4px;
    padding: 16px;
}

.chart-title {
    color: #0088ff;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 16px;
    text-align: center;
}

.chart-container {
    display: flex;
    align-items: end;
    justify-content: space-around;
    height: 150px;
    gap: 8px;
}

.chart-bar-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    flex: 1;
}

.chart-bar {
    width: 100%;
    max-width: 40px;
    background: linear-gradient(to top, #0088ff, rgba(0, 255, 0, 0.3));
    border-radius: 2px;
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    min-height: 10px;
}

.bar-value {
    color: #000;
    font-size: 10px;
    font-weight: bold;
    padding: 2px;
}

.chart-label {
    font-size: 10px;
    color: #ffffff;
    text-align: center;
    max-width: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Prize Distribution */
.prizes-section {
    padding: 16px;
}

.total-pool {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #FFD700;
    margin-bottom: 24px;
}

.prize-breakdown {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 24px;
}

.prize-item {
    display: grid;
    grid-template-columns: 60px 1fr 150px;
    gap: 16px;
    align-items: center;
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 4px;
    padding: 12px;
}

.prize-item.rank-1 {
    border-color: #FFD700;
    background: rgba(255, 215, 0, 0.1);
}

.prize-item.rank-2 {
    border-color: #C0C0C0;
    background: rgba(192, 192, 192, 0.1);
}

.prize-item.rank-3 {
    border-color: #CD7F32;
    background: rgba(205, 127, 50, 0.1);
}

.prize-rank {
    display: flex;
    justify-content: center;
}

.prize-player {
    display: flex;
    align-items: center;
}

.prize-amount {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
}

.amount {
    color: #FFD700;
    font-size: 16px;
    font-weight: bold;
}

.percentage {
    color: #999;
    font-size: 11px;
}

.prize-bar {
    grid-column: 1 / -1;
    height: 6px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 3px;
    overflow: hidden;
    margin-top: 8px;
}

.prize-fill {
    height: 100%;
    background: linear-gradient(to right, #FFD700, rgba(255, 215, 0, 0.5));
    border-radius: 3px;
    transition: width 1s ease;
}

.prize-distribution-chart {
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 4px;
    padding: 16px;
    text-align: center;
}

/* Export/Share Actions */
.footer-actions {
    display: flex;
    gap: 16px;
    align-items: center;
}

.export-section,
.share-section {
    display: flex;
    gap: 8px;
    align-items: center;
}

.export-select {
    background: rgba(0, 0, 0, 0.7);
    color: #0088ff;
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 4px 8px;
    font-family: inherit;
    font-size: 11px;
}

.export-btn {
    background: rgba(0, 255, 0, 0.2);
    color: #0088ff;
}

.share-btn {
    background: rgba(0, 136, 255, 0.2);
    color: #0088ff;
}

.print-btn {
    background: rgba(255, 255, 0, 0.2);
    color: #ffff00;
}

/* Common Tournament Styles */
.no-tournaments,
.no-matches,
.no-data,
.no-results-message {
    text-align: center;
    color: #666;
    font-style: italic;
    padding: 32px;
}

.notification {
    position: fixed;
    top: 20px;
    right: 20px;
    background: rgba(0, 0, 0, 0.9);
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 12px 16px;
    color: #0088ff;
    font-size: 12px;
    z-index: 3000;
    opacity: 0;
    transform: translateX(100%);
    transition: all 0.3s ease;
}

.notification.show {
    opacity: 1;
    transform: translateX(0);
}

.notification.success {
    border-color: #0088ff;
    background: rgba(0, 255, 0, 0.1);
}

.notification.error {
    border-color: #ff0000;
    background: rgba(255, 0, 0, 0.1);
    color: #ff0000;
}

.notification.info {
    border-color: #0088ff;
    background: rgba(0, 136, 255, 0.1);
    color: #0088ff;
}

/* Responsive Design */
@media (max-width: 768px) {
    .tournament-bracket-modal,
    .tournament-lobby-modal,
    .tournament-results-modal {
        width: 95vw;
        height: 95vh;
    }
    
    .lobby-main {
        grid-template-columns: 1fr;
    }
    
    .tournament-details {
        grid-template-columns: 1fr;
    }
    
    .form-row-group {
        grid-template-columns: 1fr;
    }
    
    .stats-grid {
        grid-template-columns: 1fr;
    }
    
    .tournament-main-info {
        flex-direction: column;
        gap: 8px;
    }
    
    .tournament-summary {
        flex-direction: column;
        gap: 16px;
        text-align: center;
    }
    
    .footer-actions {
        flex-direction: column;
        gap: 8px;
    }
}`, "",{"version":3,"sources":["webpack://./src/ui/styles/tournament-ui.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF,yCAAyC;AACzC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,iCAAiC;IACjC,6CAA6C;AACjD;;AAEA;;;IAGI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;;;IAGI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,8BAA8B;IAC9B,6CAA6C;AACjD;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,sCAAsC;IACtC,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;AAEA;;IAEI,gCAAgC;IAChC,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW,YAAY,EAAE;IACzB,MAAM,YAAY,EAAE;AACxB;;AAEA;IACI,KAAK,gCAAgC,EAAE;IACvC,MAAM,gCAAgC,EAAE;IACxC,OAAO,gCAAgC,EAAE;AAC7C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,OAAO;IACP,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;IAChB,6CAA6C;IAC7C,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,MAAM;AACV;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,oDAAoD;IACpD,WAAW;AACf;;AAEA;IACI,oDAAoD;IACpD,WAAW;AACf;;AAEA;IACI,oDAAoD;IACpD,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,2BAA2B;IAC3B,YAAY;IACZ,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,uCAAuC;AACvC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,8BAA8B;IAC9B,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;;IAEI,8BAA8B;IAC9B,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA,0BAA0B;AAC1B;IACI,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;;;IAGI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;;IAEI,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,8BAA8B;IAC9B,sCAAsC;IACtC,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,OAAO;IACP,8BAA8B;IAC9B,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,aAAa;IACb,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA,WAAW;AACX;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA,yCAAyC;AACzC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,iCAAiC;IACjC,6CAA6C;IAC7C,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mFAAmF;IACnF,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;IAChB,6CAA6C;IAC7C,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,MAAM;AACV;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,oBAAoB;AACpB;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,6BAA6B;IAC7B,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,OAAO;AACX;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kEAAkE;IAClE,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;IACnB,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,sEAAsE;IACtE,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA,6BAA6B;AAC7B;;;;IAII,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,8BAA8B;IAC9B,sCAAsC;IACtC,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;IACb,UAAU;IACV,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;IAClC,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI;;;QAGI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;AACJ","sourcesContent":["/**\n * tournament-ui.css - Tournament UI Component Styles\n * \n * Styles for tournament bracket, lobby, and results components\n * Following the retro pixel art aesthetic with terminal green colors\n */\n\n/* ===== TOURNAMENT BRACKET PANEL ===== */\n.tournament-bracket-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.8);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2000;\n}\n\n.tournament-bracket-modal {\n    width: 95vw;\n    height: 90vh;\n    background: rgba(0, 0, 0, 0.95);\n    border: 2px solid #0088ff;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 0 30px rgba(0, 255, 0, 0.5);\n}\n\n.bracket-controls {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.control-btn {\n    background: rgba(0, 255, 0, 0.1);\n    color: #0088ff;\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 4px 8px;\n    font-family: inherit;\n    font-size: 12px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.control-btn:hover {\n    background: rgba(0, 255, 0, 0.2);\n    border-color: #0088ff;\n}\n\n.tournament-info {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px;\n    background: rgba(0, 255, 0, 0.05);\n    border-bottom: 1px solid rgba(0, 255, 0, 0.2);\n}\n\n.tournament-status,\n.tournament-progress,\n.tournament-participants {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.status-value,\n.progress-value,\n.participants-value {\n    color: #ffffff;\n    font-weight: bold;\n}\n\n.bracket-format-tabs {\n    display: flex;\n    gap: 4px;\n    padding: 8px 12px;\n    background: rgba(0, 0, 0, 0.3);\n    border-bottom: 1px solid rgba(0, 255, 0, 0.2);\n}\n\n.format-tab {\n    background: rgba(0, 255, 0, 0.1);\n    color: #0088ff;\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 8px 12px;\n    font-family: inherit;\n    font-size: 12px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.format-tab.active {\n    background: rgba(0, 255, 0, 0.3);\n    border-color: #0088ff;\n    color: #000;\n    background-color: #0088ff;\n}\n\n.format-tab:hover:not(.active) {\n    background: rgba(0, 255, 0, 0.2);\n}\n\n.bracket-container {\n    flex: 1;\n    overflow: hidden;\n    position: relative;\n}\n\n.bracket-viewport {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    cursor: grab;\n    position: relative;\n}\n\n.bracket-viewport:active {\n    cursor: grabbing;\n}\n\n.bracket-canvas {\n    position: relative;\n    transform-origin: 0 0;\n    transition: transform 0.2s ease;\n    min-width: 100%;\n    min-height: 100%;\n}\n\n.bracket-round {\n    position: absolute;\n}\n\n.bracket-match {\n    position: absolute;\n    background: rgba(0, 255, 0, 0.1);\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.bracket-match:hover,\n.bracket-match.hovered {\n    background: rgba(0, 255, 0, 0.2);\n    border-color: #0088ff;\n    box-shadow: 0 0 10px rgba(0, 255, 0, 0.3);\n}\n\n.bracket-match.status-pending {\n    border-color: #666;\n    color: #999;\n}\n\n.bracket-match.status-active {\n    border-color: #ffff00;\n    background: rgba(255, 255, 0, 0.1);\n    animation: pulse-yellow 2s infinite;\n}\n\n.bracket-match.status-completed {\n    border-color: #0088ff;\n}\n\n.bracket-match.newly-completed {\n    animation: flash-green 2s ease;\n}\n\n@keyframes pulse-yellow {\n    0%, 100% { opacity: 0.7; }\n    50% { opacity: 1.0; }\n}\n\n@keyframes flash-green {\n    0% { background: rgba(0, 255, 0, 0.1); }\n    50% { background: rgba(0, 255, 0, 0.5); }\n    100% { background: rgba(0, 255, 0, 0.1); }\n}\n\n.match-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 4px;\n    font-size: 10px;\n}\n\n.match-id {\n    font-weight: bold;\n    color: #0088ff;\n}\n\n.match-status {\n    text-transform: uppercase;\n    font-size: 9px;\n}\n\n.match-status.pending {\n    color: #666;\n}\n\n.match-status.active {\n    color: #ffff00;\n}\n\n.match-status.completed {\n    color: #0088ff;\n}\n\n.match-players {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.match-player {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 2px 4px;\n    border-radius: 2px;\n    font-size: 11px;\n}\n\n.match-player.winner {\n    background: rgba(0, 255, 0, 0.2);\n    color: #0088ff;\n    font-weight: bold;\n}\n\n.match-vs {\n    text-align: center;\n    font-size: 9px;\n    color: #666;\n    margin: 2px 0;\n}\n\n.winner-icon {\n    font-size: 10px;\n}\n\n.standings-container,\n.matches-container {\n    flex: 1;\n    overflow-y: auto;\n    padding: 12px;\n}\n\n.standings-table-wrapper {\n    overflow-x: auto;\n}\n\n.standings-table {\n    width: 100%;\n    border-collapse: collapse;\n    background: rgba(0, 0, 0, 0.3);\n}\n\n.standings-table th,\n.standings-table td {\n    padding: 8px 12px;\n    text-align: left;\n    border-bottom: 1px solid rgba(0, 255, 0, 0.2);\n    font-size: 12px;\n}\n\n.standings-table th {\n    background: rgba(0, 255, 0, 0.1);\n    color: #0088ff;\n    font-weight: bold;\n    position: sticky;\n    top: 0;\n}\n\n.standings-row.eliminated {\n    opacity: 0.6;\n}\n\n.standings-row.finalist {\n    background: rgba(0, 255, 0, 0.05);\n}\n\n.rank-badge {\n    display: inline-block;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    text-align: center;\n    line-height: 24px;\n    font-weight: bold;\n    font-size: 11px;\n}\n\n.rank-badge.gold {\n    background: linear-gradient(45deg, #FFD700, #FFA500);\n    color: #000;\n}\n\n.rank-badge.silver {\n    background: linear-gradient(45deg, #C0C0C0, #808080);\n    color: #000;\n}\n\n.rank-badge.bronze {\n    background: linear-gradient(45deg, #CD7F32, #8B4513);\n    color: #fff;\n}\n\n.match-details-panel {\n    position: absolute;\n    top: 50%;\n    right: 20px;\n    transform: translateY(-50%);\n    width: 300px;\n    background: rgba(0, 0, 0, 0.95);\n    border: 2px solid #0088ff;\n    border-radius: 4px;\n    padding: 16px;\n    visibility: hidden;\n    opacity: 0;\n    transition: all 0.3s ease;\n}\n\n.match-details-panel.visible {\n    visibility: visible;\n    opacity: 1;\n}\n\n.match-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.match-title {\n    font-weight: bold;\n    color: #0088ff;\n}\n\n.close-details-btn {\n    background: none;\n    border: none;\n    color: #0088ff;\n    font-size: 16px;\n    cursor: pointer;\n    padding: 0;\n    width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.match-detail-row {\n    margin-bottom: 8px;\n    font-size: 12px;\n}\n\n.detail-label {\n    color: #0088ff;\n    font-weight: bold;\n}\n\n.detail-value {\n    color: #ffffff;\n}\n\n.detail-players {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-top: 4px;\n}\n\n.detail-player {\n    padding: 4px 8px;\n    border-radius: 2px;\n    background: rgba(0, 255, 0, 0.05);\n}\n\n.detail-player.winner {\n    background: rgba(0, 255, 0, 0.2);\n    color: #0088ff;\n    font-weight: bold;\n}\n\n.detail-vs {\n    text-align: center;\n    color: #666;\n    font-size: 10px;\n}\n\n.bracket-legend {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n}\n\n.legend-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 11px;\n}\n\n.legend-color {\n    width: 12px;\n    height: 12px;\n    border-radius: 2px;\n}\n\n.legend-color.pending {\n    background: #666;\n}\n\n.legend-color.active {\n    background: #ffff00;\n}\n\n.legend-color.completed {\n    background: #0088ff;\n}\n\n/* ===== TOURNAMENT LOBBY PANEL ===== */\n.tournament-lobby-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.8);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2000;\n}\n\n.tournament-lobby-modal {\n    width: 90vw;\n    height: 85vh;\n    max-width: 1200px;\n    background: rgba(0, 0, 0, 0.95);\n    border: 2px solid #0088ff;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 0 30px rgba(0, 255, 0, 0.5);\n}\n\n.lobby-nav {\n    display: flex;\n    gap: 4px;\n}\n\n.nav-btn {\n    background: rgba(0, 255, 0, 0.1);\n    color: #0088ff;\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 6px 12px;\n    font-family: inherit;\n    font-size: 12px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.nav-btn.active {\n    background: #0088ff;\n    color: #000;\n}\n\n.nav-btn:hover:not(.active) {\n    background: rgba(0, 255, 0, 0.2);\n}\n\n.view-container {\n    flex: 1;\n    padding: 16px;\n    overflow-y: auto;\n}\n\n.view-container.hidden {\n    display: none;\n}\n\n.tournaments-filters {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n    margin-bottom: 16px;\n    padding: 12px;\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 4px;\n}\n\n.filter-group {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.filter-select {\n    background: rgba(0, 0, 0, 0.7);\n    color: #0088ff;\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 4px 8px;\n    font-family: inherit;\n    font-size: 12px;\n}\n\n.refresh-btn {\n    background: rgba(0, 255, 0, 0.1);\n    color: #0088ff;\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 6px 12px;\n    font-family: inherit;\n    font-size: 12px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    transition: all 0.2s ease;\n}\n\n.refresh-btn:hover {\n    background: rgba(0, 255, 0, 0.2);\n}\n\n.tournaments-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.tournament-item {\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 16px;\n    transition: all 0.2s ease;\n}\n\n.tournament-item:hover {\n    background: rgba(0, 255, 0, 0.1);\n    border-color: #0088ff;\n}\n\n.tournament-item.status-registration {\n    border-left: 4px solid #ffff00;\n}\n\n.tournament-item.status-active {\n    border-left: 4px solid #ff8800;\n}\n\n.tournament-item.status-completed {\n    border-left: 4px solid #0088ff;\n}\n\n.tournament-main-info {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 12px;\n}\n\n.tournament-name {\n    font-size: 16px;\n    font-weight: bold;\n    color: #ffffff;\n    margin-bottom: 4px;\n}\n\n.tournament-meta {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n}\n\n.tournament-format,\n.tournament-status {\n    padding: 2px 6px;\n    border-radius: 2px;\n    font-size: 10px;\n    font-weight: bold;\n    text-transform: uppercase;\n}\n\n.tournament-format {\n    background: rgba(0, 255, 0, 0.2);\n    color: #0088ff;\n}\n\n.tournament-status.status-registration {\n    background: rgba(255, 255, 0, 0.2);\n    color: #ffff00;\n}\n\n.tournament-status.status-active {\n    background: rgba(255, 136, 0, 0.2);\n    color: #ff8800;\n}\n\n.tournament-status.status-completed {\n    background: rgba(0, 255, 0, 0.2);\n    color: #0088ff;\n}\n\n.tournament-details {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    gap: 8px;\n    margin-bottom: 12px;\n}\n\n.detail-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 12px;\n}\n\n.detail-label {\n    color: #0088ff;\n    font-weight: bold;\n}\n\n.detail-value {\n    color: #ffffff;\n}\n\n.detail-value.urgent {\n    color: #ff0000;\n    animation: pulse 1s infinite;\n}\n\n.detail-value.prize {\n    color: #ffff00;\n    font-weight: bold;\n}\n\n.tournament-actions {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.join-btn {\n    background: rgba(0, 255, 0, 0.2);\n    color: #0088ff;\n}\n\n.spectate-btn {\n    background: rgba(0, 136, 255, 0.2);\n    color: #0088ff;\n}\n\n.info-btn {\n    background: rgba(255, 255, 0, 0.2);\n    color: #ffff00;\n}\n\n/* Create Tournament Form */\n.create-tournament-form {\n    max-width: 600px;\n    margin: 0 auto;\n}\n\n.form-section {\n    margin-bottom: 24px;\n}\n\n.section-title {\n    color: #0088ff;\n    font-size: 14px;\n    font-weight: bold;\n    margin-bottom: 16px;\n    padding-bottom: 4px;\n    border-bottom: 1px solid rgba(0, 255, 0, 0.3);\n}\n\n.form-row {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-bottom: 12px;\n}\n\n.form-row label {\n    color: #0088ff;\n    font-size: 12px;\n    font-weight: bold;\n}\n\n.form-row-group {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n    margin-bottom: 12px;\n}\n\n.form-input,\n.form-select {\n    background: rgba(0, 0, 0, 0.7);\n    color: #ffffff;\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 8px 12px;\n    font-family: inherit;\n    font-size: 12px;\n}\n\n.form-input:focus,\n.form-select:focus {\n    outline: none;\n    border-color: #0088ff;\n    box-shadow: 0 0 5px rgba(0, 255, 0, 0.3);\n}\n\n.checkbox-label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    color: #0088ff;\n    font-size: 12px;\n}\n\n.checkbox-custom {\n    width: 16px;\n    height: 16px;\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 2px;\n    position: relative;\n    background: rgba(0, 0, 0, 0.7);\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n    display: none;\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked + .checkbox-custom {\n    background: #0088ff;\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked + .checkbox-custom::after {\n    content: '✓';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    color: #000;\n    font-size: 12px;\n    font-weight: bold;\n}\n\n.form-actions {\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n    margin-top: 24px;\n}\n\n.create-btn {\n    background: rgba(0, 255, 0, 0.2);\n    color: #0088ff;\n}\n\n.cancel-btn {\n    background: rgba(255, 0, 0, 0.2);\n    color: #ff0000;\n}\n\n/* Tournament Lobby View */\n.tournament-header {\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 4px;\n    padding: 16px;\n    margin-bottom: 16px;\n}\n\n.tournament-title {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 12px;\n}\n\n.tournament-name {\n    font-size: 18px;\n    font-weight: bold;\n    color: #ffffff;\n}\n\n.tournament-badges {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.format-badge,\n.status-badge,\n.spectator-badge {\n    padding: 2px 6px;\n    border-radius: 2px;\n    font-size: 10px;\n    font-weight: bold;\n    text-transform: uppercase;\n}\n\n.format-badge {\n    background: rgba(0, 255, 0, 0.2);\n    color: #0088ff;\n}\n\n.status-badge.status-registration {\n    background: rgba(255, 255, 0, 0.2);\n    color: #ffff00;\n}\n\n.status-badge.status-active {\n    background: rgba(255, 136, 0, 0.2);\n    color: #ff8800;\n}\n\n.spectator-badge {\n    background: rgba(0, 136, 255, 0.2);\n    color: #0088ff;\n}\n\n.tournament-stats {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n    gap: 16px;\n}\n\n.stat-item {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.stat-label {\n    color: #0088ff;\n    font-size: 11px;\n    font-weight: bold;\n}\n\n.stat-value {\n    color: #ffffff;\n    font-size: 14px;\n}\n\n.stat-value.prize {\n    color: #ffff00;\n    font-weight: bold;\n}\n\n.lobby-main {\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    gap: 24px;\n    margin-bottom: 16px;\n}\n\n.players-section,\n.chat-section {\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 4px;\n    padding: 16px;\n}\n\n.section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.section-title {\n    color: #0088ff;\n    font-size: 14px;\n    font-weight: bold;\n}\n\n.player-count {\n    color: #ffffff;\n    font-size: 12px;\n}\n\n.players-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 12px;\n    margin-bottom: 16px;\n}\n\n.player-card {\n    background: rgba(0, 255, 0, 0.1);\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 12px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    transition: all 0.2s ease;\n}\n\n.player-card.current-user {\n    border-color: #ffff00;\n    background: rgba(255, 255, 0, 0.1);\n}\n\n.player-card.empty {\n    border-style: dashed;\n    opacity: 0.5;\n    justify-content: center;\n}\n\n.player-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: rgba(0, 255, 0, 0.2);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    color: #0088ff;\n}\n\n.player-info {\n    flex: 1;\n}\n\n.player-name {\n    font-weight: bold;\n    color: #ffffff;\n    margin-bottom: 2px;\n}\n\n.player-meta {\n    display: flex;\n    gap: 8px;\n    font-size: 10px;\n    color: #999;\n}\n\n.current-user-indicator {\n    background: #ffff00;\n    color: #000;\n    padding: 2px 6px;\n    border-radius: 2px;\n    font-size: 9px;\n    font-weight: bold;\n}\n\n.empty-slot {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n    color: #666;\n}\n\n.empty-icon {\n    font-size: 18px;\n}\n\n.empty-text {\n    font-size: 10px;\n}\n\n.registration-actions {\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n}\n\n.leave-tournament-btn {\n    background: rgba(255, 0, 0, 0.2);\n    color: #ff0000;\n}\n\n.ready-btn {\n    background: rgba(0, 255, 0, 0.2);\n    color: #0088ff;\n}\n\n.join-tournament-btn {\n    background: rgba(0, 255, 0, 0.2);\n    color: #0088ff;\n}\n\n/* Chat Section */\n.chat-controls {\n    display: flex;\n    gap: 4px;\n}\n\n.chat-control-btn {\n    background: rgba(0, 255, 0, 0.1);\n    color: #0088ff;\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 2px;\n    padding: 2px 4px;\n    font-size: 10px;\n    cursor: pointer;\n}\n\n.chat-messages {\n    height: 200px;\n    overflow-y: auto;\n    background: rgba(0, 0, 0, 0.3);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 4px;\n    padding: 8px;\n    margin-bottom: 8px;\n}\n\n.chat-message {\n    margin-bottom: 8px;\n    font-size: 11px;\n}\n\n.chat-message.type-system {\n    color: #ffff00;\n    font-style: italic;\n}\n\n.chat-message.type-player {\n    color: #ffffff;\n}\n\n.message-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2px;\n}\n\n.sender-name {\n    font-weight: bold;\n    color: #0088ff;\n}\n\n.message-time {\n    color: #666;\n    font-size: 9px;\n}\n\n.message-content {\n    color: #ffffff;\n}\n\n.chat-input-section {\n    display: flex;\n    gap: 8px;\n}\n\n.chat-input {\n    flex: 1;\n    background: rgba(0, 0, 0, 0.7);\n    color: #ffffff;\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 6px 8px;\n    font-family: inherit;\n    font-size: 11px;\n}\n\n.send-btn {\n    background: rgba(0, 255, 0, 0.2);\n    color: #0088ff;\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 6px 8px;\n    cursor: pointer;\n    font-size: 10px;\n}\n\n/* Countdown Section */\n.countdown-section {\n    text-align: center;\n    padding: 16px;\n    background: rgba(255, 255, 0, 0.1);\n    border: 1px solid rgba(255, 255, 0, 0.3);\n    border-radius: 4px;\n}\n\n.countdown-timer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n}\n\n.countdown-label {\n    color: #ffff00;\n    font-size: 12px;\n    font-weight: bold;\n}\n\n.countdown-display {\n    color: #ffffff;\n    font-size: 24px;\n    font-weight: bold;\n    font-family: 'Courier New', monospace;\n}\n\n/* Footer */\n.panel-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    background: rgba(0, 0, 0, 0.5);\n    border-top: 1px solid rgba(0, 255, 0, 0.2);\n}\n\n.footer-info {\n    display: flex;\n    gap: 16px;\n    font-size: 11px;\n    color: #999;\n}\n\n/* ===== TOURNAMENT RESULTS PANEL ===== */\n.tournament-results-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.8);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2000;\n}\n\n.tournament-results-modal {\n    width: 90vw;\n    height: 85vh;\n    max-width: 1200px;\n    background: rgba(0, 0, 0, 0.95);\n    border: 2px solid #0088ff;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 0 30px rgba(0, 255, 0, 0.5);\n}\n\n.results-nav {\n    display: flex;\n    gap: 4px;\n}\n\n.tournament-summary {\n    background: rgba(0, 255, 0, 0.05);\n    border-bottom: 1px solid rgba(0, 255, 0, 0.2);\n    padding: 16px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.summary-main {\n    flex: 1;\n}\n\n.tournament-title {\n    color: #ffffff;\n    font-size: 18px;\n    font-weight: bold;\n    margin-bottom: 12px;\n}\n\n.tournament-info-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n    gap: 16px;\n}\n\n.info-item {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.info-label {\n    color: #0088ff;\n    font-size: 11px;\n    font-weight: bold;\n}\n\n.info-value {\n    color: #ffffff;\n    font-size: 14px;\n}\n\n.winner-spotlight {\n    background: linear-gradient(45deg, rgba(255, 215, 0, 0.1), rgba(255, 215, 0, 0.05));\n    border: 2px solid #FFD700;\n    border-radius: 8px;\n    padding: 16px;\n    text-align: center;\n    min-width: 200px;\n}\n\n.winner-crown {\n    font-size: 24px;\n    margin-bottom: 8px;\n}\n\n.winner-name {\n    color: #FFD700;\n    font-size: 16px;\n    font-weight: bold;\n    margin-bottom: 4px;\n}\n\n.winner-title {\n    color: #ffffff;\n    font-size: 12px;\n    margin-bottom: 8px;\n}\n\n.winner-stats {\n    display: flex;\n    justify-content: space-around;\n    gap: 8px;\n}\n\n.winner-stat {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    font-size: 10px;\n}\n\n.winner-stat .stat-label {\n    color: #0088ff;\n}\n\n.winner-stat .stat-value {\n    color: #ffffff;\n    font-weight: bold;\n}\n\n.winner-stat .stat-value.prize {\n    color: #FFD700;\n}\n\n/* Standings View */\n.standings-section {\n    padding: 16px;\n}\n\n.standings-controls {\n    display: flex;\n    gap: 8px;\n}\n\n.sort-btn {\n    background: rgba(0, 255, 0, 0.1);\n    color: #0088ff;\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 4px 8px;\n    font-size: 11px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.sort-btn.active {\n    background: rgba(0, 255, 0, 0.3);\n    border-color: #0088ff;\n}\n\n.standings-table-container {\n    margin: 16px 0;\n    overflow-x: auto;\n}\n\n.results-table {\n    width: 100%;\n    border-collapse: collapse;\n    background: rgba(0, 0, 0, 0.3);\n}\n\n.results-table th,\n.results-table td {\n    padding: 8px 12px;\n    text-align: left;\n    border-bottom: 1px solid rgba(0, 255, 0, 0.2);\n    font-size: 12px;\n}\n\n.results-table th {\n    background: rgba(0, 255, 0, 0.1);\n    color: #0088ff;\n    font-weight: bold;\n    position: sticky;\n    top: 0;\n}\n\n.standings-row.rank-1 {\n    background: rgba(255, 215, 0, 0.1);\n}\n\n.standings-row.rank-2 {\n    background: rgba(192, 192, 192, 0.1);\n}\n\n.standings-row.rank-3 {\n    background: rgba(205, 127, 50, 0.1);\n}\n\n.standings-row.eliminated {\n    opacity: 0.6;\n}\n\n.prize-cell.has-prize {\n    color: #FFD700;\n    font-weight: bold;\n}\n\n.podium-display {\n    margin-top: 24px;\n    display: flex;\n    justify-content: center;\n}\n\n.podium {\n    display: flex;\n    align-items: end;\n    gap: 8px;\n}\n\n.podium-position {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n}\n\n.podium-player {\n    background: rgba(0, 255, 0, 0.1);\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 12px;\n    text-align: center;\n    min-width: 100px;\n}\n\n.podium-rank {\n    font-size: 18px;\n    font-weight: bold;\n    color: #0088ff;\n}\n\n.podium-name {\n    color: #ffffff;\n    font-size: 14px;\n    margin: 4px 0;\n}\n\n.podium-prize {\n    color: #FFD700;\n    font-size: 12px;\n    font-weight: bold;\n}\n\n.podium-base {\n    font-size: 32px;\n    height: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.podium-position.first .podium-base {\n    height: 80px;\n}\n\n.podium-position.second .podium-base {\n    height: 70px;\n}\n\n.podium-position.third .podium-base {\n    height: 60px;\n}\n\n/* Match History */\n.history-section {\n    padding: 16px;\n}\n\n.history-controls {\n    display: flex;\n    gap: 12px;\n}\n\n.matches-timeline {\n    margin-top: 16px;\n}\n\n.timeline-round {\n    margin-bottom: 24px;\n}\n\n.round-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n    padding-bottom: 4px;\n    border-bottom: 1px solid rgba(0, 255, 0, 0.3);\n}\n\n.round-title {\n    color: #0088ff;\n    font-size: 14px;\n    font-weight: bold;\n}\n\n.round-meta {\n    color: #999;\n    font-size: 11px;\n}\n\n.round-matches {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.timeline-match {\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 4px;\n    padding: 12px;\n}\n\n.match-timeline-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 6px;\n    font-size: 11px;\n}\n\n.match-id {\n    color: #0088ff;\n    font-weight: bold;\n}\n\n.match-time {\n    color: #999;\n}\n\n.match-timeline-players {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 4px;\n}\n\n.timeline-player {\n    flex: 1;\n    padding: 4px 8px;\n    border-radius: 2px;\n    text-align: center;\n    font-size: 12px;\n}\n\n.timeline-player.winner {\n    background: rgba(0, 255, 0, 0.2);\n    color: #0088ff;\n    font-weight: bold;\n}\n\n.timeline-player.loser {\n    background: rgba(255, 0, 0, 0.1);\n    color: #999;\n}\n\n.timeline-vs {\n    color: #666;\n    font-size: 10px;\n}\n\n.match-timeline-stats {\n    font-size: 10px;\n    color: #999;\n}\n\n/* Statistics View */\n.statistics-section {\n    padding: 16px;\n}\n\n.stats-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n.stats-card {\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 4px;\n    padding: 16px;\n}\n\n.stats-card-title {\n    color: #0088ff;\n    font-size: 14px;\n    font-weight: bold;\n    margin-bottom: 12px;\n    padding-bottom: 4px;\n    border-bottom: 1px solid rgba(0, 255, 0, 0.3);\n}\n\n.stats-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.stat-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 12px;\n}\n\n.player-performance-chart {\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 4px;\n    padding: 16px;\n}\n\n.chart-title {\n    color: #0088ff;\n    font-size: 14px;\n    font-weight: bold;\n    margin-bottom: 16px;\n    text-align: center;\n}\n\n.chart-container {\n    display: flex;\n    align-items: end;\n    justify-content: space-around;\n    height: 150px;\n    gap: 8px;\n}\n\n.chart-bar-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    flex: 1;\n}\n\n.chart-bar {\n    width: 100%;\n    max-width: 40px;\n    background: linear-gradient(to top, #0088ff, rgba(0, 255, 0, 0.3));\n    border-radius: 2px;\n    position: relative;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n    min-height: 10px;\n}\n\n.bar-value {\n    color: #000;\n    font-size: 10px;\n    font-weight: bold;\n    padding: 2px;\n}\n\n.chart-label {\n    font-size: 10px;\n    color: #ffffff;\n    text-align: center;\n    max-width: 60px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n/* Prize Distribution */\n.prizes-section {\n    padding: 16px;\n}\n\n.total-pool {\n    text-align: center;\n    font-size: 18px;\n    font-weight: bold;\n    color: #FFD700;\n    margin-bottom: 24px;\n}\n\n.prize-breakdown {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-bottom: 24px;\n}\n\n.prize-item {\n    display: grid;\n    grid-template-columns: 60px 1fr 150px;\n    gap: 16px;\n    align-items: center;\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 4px;\n    padding: 12px;\n}\n\n.prize-item.rank-1 {\n    border-color: #FFD700;\n    background: rgba(255, 215, 0, 0.1);\n}\n\n.prize-item.rank-2 {\n    border-color: #C0C0C0;\n    background: rgba(192, 192, 192, 0.1);\n}\n\n.prize-item.rank-3 {\n    border-color: #CD7F32;\n    background: rgba(205, 127, 50, 0.1);\n}\n\n.prize-rank {\n    display: flex;\n    justify-content: center;\n}\n\n.prize-player {\n    display: flex;\n    align-items: center;\n}\n\n.prize-amount {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 2px;\n}\n\n.amount {\n    color: #FFD700;\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.percentage {\n    color: #999;\n    font-size: 11px;\n}\n\n.prize-bar {\n    grid-column: 1 / -1;\n    height: 6px;\n    background: rgba(0, 0, 0, 0.3);\n    border-radius: 3px;\n    overflow: hidden;\n    margin-top: 8px;\n}\n\n.prize-fill {\n    height: 100%;\n    background: linear-gradient(to right, #FFD700, rgba(255, 215, 0, 0.5));\n    border-radius: 3px;\n    transition: width 1s ease;\n}\n\n.prize-distribution-chart {\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 4px;\n    padding: 16px;\n    text-align: center;\n}\n\n/* Export/Share Actions */\n.footer-actions {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n}\n\n.export-section,\n.share-section {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.export-select {\n    background: rgba(0, 0, 0, 0.7);\n    color: #0088ff;\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 4px 8px;\n    font-family: inherit;\n    font-size: 11px;\n}\n\n.export-btn {\n    background: rgba(0, 255, 0, 0.2);\n    color: #0088ff;\n}\n\n.share-btn {\n    background: rgba(0, 136, 255, 0.2);\n    color: #0088ff;\n}\n\n.print-btn {\n    background: rgba(255, 255, 0, 0.2);\n    color: #ffff00;\n}\n\n/* Common Tournament Styles */\n.no-tournaments,\n.no-matches,\n.no-data,\n.no-results-message {\n    text-align: center;\n    color: #666;\n    font-style: italic;\n    padding: 32px;\n}\n\n.notification {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    background: rgba(0, 0, 0, 0.9);\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 12px 16px;\n    color: #0088ff;\n    font-size: 12px;\n    z-index: 3000;\n    opacity: 0;\n    transform: translateX(100%);\n    transition: all 0.3s ease;\n}\n\n.notification.show {\n    opacity: 1;\n    transform: translateX(0);\n}\n\n.notification.success {\n    border-color: #0088ff;\n    background: rgba(0, 255, 0, 0.1);\n}\n\n.notification.error {\n    border-color: #ff0000;\n    background: rgba(255, 0, 0, 0.1);\n    color: #ff0000;\n}\n\n.notification.info {\n    border-color: #0088ff;\n    background: rgba(0, 136, 255, 0.1);\n    color: #0088ff;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .tournament-bracket-modal,\n    .tournament-lobby-modal,\n    .tournament-results-modal {\n        width: 95vw;\n        height: 95vh;\n    }\n    \n    .lobby-main {\n        grid-template-columns: 1fr;\n    }\n    \n    .tournament-details {\n        grid-template-columns: 1fr;\n    }\n    \n    .form-row-group {\n        grid-template-columns: 1fr;\n    }\n    \n    .stats-grid {\n        grid-template-columns: 1fr;\n    }\n    \n    .tournament-main-info {\n        flex-direction: column;\n        gap: 8px;\n    }\n    \n    .tournament-summary {\n        flex-direction: column;\n        gap: 16px;\n        text-align: center;\n    }\n    \n    .footer-actions {\n        flex-direction: column;\n        gap: 8px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
